import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.client_report_local',
  local_managed: 'reporting.client_report_local_managed',
};
